import Config from "../../utils/config/config.js";
import { fileToBase64 } from "../FilesService.js";
import GenericAjax from "../GenericAjax.js";
import { buildRequest } from "../socket/initWebSocket.js";
import { getConnectionIdLS, getSessinIdFromLS } from "../storage/LocalStorage.js";
import Api from "../userApiServices/axiosInstance.js";

const baseUrl = Config.gRPCURL
const daily_baseUrl = Config.daily_baseUrl;
const xApiKey = Config.xApiKey;
const filesAPI = Config.filesAPI;


const getSubcribeBotsList = (params) => {
	const url = `${baseUrl}/grpc/user.UserService/GetBotSubscriptionsInfo`
	
	return Api.post(url, params);
};

const getUserDomainsList = () => {
	const url = `${baseUrl}/grpc/user.UserService/GetUserDomains`
	return Api.post(url);
};

const getContacts = (params) => {
	const url = `${baseUrl}/grpc/user.UserService/GetContacts`
	return Api.post(url, params);
}

const subscribeDomain = async(payload) => {
	const req = buildRequest("UserService", "SubscribeDomain", payload);
	const res = await Api.post(url, req);
	return res.data.payload;
}

const deleteUser = (req) => {
	const url = `${baseUrl}/grpc/auth.AuthService/DeleteUser`
	return Api.post(url, req);
}

const changePassword = (req) => {
	const url = `${baseUrl}/grpc/auth.AuthService/ChangePassword`
	return Api.post(url, req);
}

const initiateSoftwareMfa = (req) => {
	const url = `${baseUrl}/grpc/auth.AuthService/InitiateSoftwareMfa`
	return Api.post(url, req);
}

const activeSoftwareMfa = (req) => {
	const url = `${baseUrl}/grpc/auth.AuthService/ActivateSoftwareMfa`
	return Api.post(url, req);
}

const deactivateSoftwareMfa = (req) => {
	const url = `${baseUrl}/grpc/auth.AuthService/DeactivateSoftwareMfa`
	return Api.post(url, req);
}

const execute = (params) => {
	const url = `${baseUrl}/grpc/agentguard.AgentGuardService/Execute`;
	return Api.post(url, params);
};

const fetchUserDetails = (params) => {
	const url = `${baseUrl}/grpc/user.UserService/GetUserDetails`;
	return Api.post(url, params);
};

const initiateStripePayment = (params) => {
	const url = `${baseUrl}/grpc/payment.PaymentService/InitiatePayment`;
	return Api.post(url, params);
};

const confirmStripePayment = (params) => {
	const url = `${baseUrl}/grpc/payment.PaymentService/ConfirmPayment`;
	return Api.post(url, params);
};

const downloadFile = (url) => {
	return Api.get(url, {
		responseType: "blob"
	});
};

const getCallHistory = () => {
	const url = `${baseUrl}/grpc/user.UserService/GetCallHistory`
	return Api.post(url);
};

const getPaginatedCallHistory = (startTime, domainName) => {
	let data = { startTime: startTime, selectedDomain: domainName };
	const url = `${baseUrl}/grpc/user.UserService/GetPaginatedCallHistory`
	return Api.post(url, data);
};

const sendVoipCall = (callInfo) => {
	const url = `${baseUrl}/grpc/user.UserService/SendVoipPushNotification`
	return Api.post(url, callInfo);
}

const sendUserAvailableForCall = () => {
	const url = `${baseUrl}/grpc/user.UserService/SetUserAvailableForCall`
	return Api.post(url);
}

const getCatalog = (params) => {
	const url = `${baseUrl}/grpc/conversation.ConversationService/GetCatalog`
	return Api.post(url, params);
};

const subscribeBot = (params) => {
	const url = `${baseUrl}/grpc/user.UserService/SubscribeBot`
	return Api.post(url, params);
};

const getTimeLine = (params) => {
	let details = { isWebRequest: true, selectedDomain: params }
	const url = `${baseUrl}/grpc/conversation.ConversationService/GetTimeline`
	return Api.post(url, details);
};

const updateMessageStatusForUser = ({ messageIds, userDomain, conversationId, action }) => {
	const url = `${baseUrl}/grpc/conversation.ConversationService/UpdateMessageStatusForUser`;
	return Api.post(url, { conversationId, userDomain, messageIds, action });
};

const generateTwilioToken = (params) => {
	const url = `${baseUrl}/grpc/user.UserService/GenerateWebTwilioToken`;
	return Api.post(url, params);
};

const getSubcribeChannelList = (params) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/GetSubscribed`
	return Api.post(url, params);
};

const getContactHistory = (params) => {
	const url = `${baseUrl}/grpc/user.UserService/GetCallHistoryForContact`
	return Api.post(url, params);
};


const updateFavourites = (params) => {
	const url = `${baseUrl}/grpc/conversation.ConversationService/UpdateFavourites`
	return Api.post(url, params);
};

const createNewGroup = (params) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/Create`
	return Api.post(url, params).then(handleResponse);
};

const addGroupParticipants = (params) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/AddParticipants`
	return Api.post(url, params);
};

const getParticipants = (params) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/GetParticipants`
	return Api.post(url, params);
};
const editChannel = (channelObj) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/Edit`;
	return Api.post(url, channelObj).then(handleResponse);
}

export function updateParticipants(participants) {
	const url = `${baseUrl}/grpc/channels.ChannelsService/UpdateParticipants`;

	return Api.post(url, {
		...participants,
	}).then((data) => {
		if (data.data.error && data.data.error !== "0") {
			return [];
		} else {
			return data.data.content || [];
		}
	});
}

export const subscribeChannel = (domainChannels) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/Subscribe`;
	return Api.post(url, { domainChannels }).then(handleResponse);
};

export const unsubscribeChannel = (userDomain, channelName) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/Unsubscribe`;
	return Api.post(url, {
		domainChannels: [
			{
				userDomain,
				channels: [channelName],
			},
		],
	}).then(handleResponse);
};

const getSubscribedChannels = (domainSelected) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/GetSubscribed`;
	return Api.post(url, domainSelected);
};

const getUnsubscribedChannels = (domainSelected) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/GetUnsubscribed`;
	return Api.post(url, domainSelected);
};

export const addUsersToChannel = (channelData) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/AddParticipants`;
	return Api.post(url, {
		channelName: channelData.channelName,
		userDomain: channelData.userDomain || "frontmai",
		newUserIds: [...channelData.newUserIds],
	}).then(handleResponse);
};

export function uploadImageFile(
	startingPath,
	channelId,
	fileName,
	file,
	onUploadProgress
) {
	console.log('file', file)
	return fileToBase64(file).then((base64Str) => {
		return GenericAjax.uploadFile(
			`${filesAPI}/${startingPath}/${channelId}/${fileName}`,
			base64Str,
			file.type,
			onUploadProgress
		);
	});
}
export const requestAccessToPrivateChannel = ({ channelName, userDomain }) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/RequestPrivateChannelAccess`;
	return Api.post(url, { channelName, userDomain }).then(handleResponse);
};

export const fetchPendingParticipants = (channelName, userDomain) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/GetPendingParticipants`;
	return Api.post(url, { channelName, userDomain }).then(handleResponse);
};

export const fetchChannelParticipants = (channelName, userDomain) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/GetParticipants`;
	return Api.post(url, { channelName, userDomain })
};

export const authorizeParticipants = (channelName, userDomain, acceptedList, ignoredList) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/AuthorizeParticipants`;
	return Api.post(url, {
		channelName,
		userDomain,
		accepted: [...acceptedList],
		ignored: [...ignoredList],
	}).then(handleResponse);
};

export const deleteChannel = ({ channelName, userDomain }) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/DeleteChannel`;
	return Api.post(url, { channelName, userDomain }).then(handleResponse);
};

export const changeChannelOwner = ({ channelName, userDomain, newOwnerId }) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/ChangeOwner`;
	return Api.post(url, { channelName, userDomain, newOwnerId })
};

const updateChannelAdmin = ({ channelName, userDomain, admins }) => {
	console.log('updateChannelAdmin', { channelName, userDomain, admins })
	const url = `${baseUrl}/grpc/channels.ChannelsService/UpdateChannelAdmins`;
	return Api.post(url, {
		channelName,
		userDomain,
		userIds: admins,
	})
};

export const getChannelAdmins = ({ channelName, userDomain }) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/GetChannelAdmins`;
	return Api.post(url, { channelName, userDomain }).then(handleResponse);
};

export const findNewParticipants = (searchData) => {
	const url = `${baseUrl}/grpc/channels.ChannelsService/FindNewParticipants`;
	return Api.post(url, searchData).then(handleResponse);
};

function handleResponse(data) {
	if (data.error && data.error !== "0") {
		console.error("API error:", data.error);
		return null;
	}
	return data.data.content || [];
}

const rejectCall = async (meetingId) => {
	try {
		const response = await fetch(`${daily_baseUrl}/endMeeting`, {
			method: 'POST',
			body: JSON.stringify({ meetingId: meetingId }),
			headers: {
				'x-api-key': xApiKey,
				'Content-Type': 'application/json'
			}
		});

		if (!response.ok) {
			throw new Error(`Error: ${response.status} - ${response.statusText}`);
		}

		const responseData = await response.json();
		return responseData;
	} catch (error) {
		console.error('Failed to reject call:', error);
		return { success: false, error: error.message };
	}
};

const leaveCall = async (meetingId, userEmail) => {
	try {
		const response = await fetch(`${daily_baseUrl}/leaveMeeting`, {
			method: 'POST',
			body: JSON.stringify({
				meetingId: meetingId,
				"userEmail": userEmail,
				"is_breakout": false
			}),
			headers: {
				'x-api-key': xApiKey,
				'Content-Type': 'application/json'
			}
		});

		if (!response.ok) {
			throw new Error(`Error: ${response.status} - ${response.statusText}`);
		}

		const responseData = await response.json();
		return responseData;
	} catch (error) {
		console.error('Failed to reject call:', error);
		return { success: false, error: error.message };
	}
};

const fetchFavourite = async (reqInfo) => {
	const url = `${baseUrl}/grpc/conversation.ConversationService/GetFavouriteConversations`;
	return Api.post(url, reqInfo);
};

const signupUser = async (signupObj) => {
	const req = buildRequest("AuthService", "Signup", signupObj);
    const res = await Api.post(req);
	return res.data.payload;
}
const verifyOtp = async(otpbj) => {
	const req = buildRequest("AuthService", "ConfirmSignup", otpbj);
    const res = await Api.post(req);
	return res.data.payload;
}
const resendOtp = async(otpObj) => {
	const req = buildRequest("AuthService", "ResendSignupConfirmCode", otpObj);
    const res = await Api.post(req);
	return res.data.payload;

}

const resetPassword = async (reqInfo) => {
	const req = buildRequest("AuthService", "ResetPassword", reqInfo);

	const response = await Api.post(req);
	return response?.data?.payload;
};

const confirmPassword = async (reqInfo) => {
	const req = buildRequest("AuthService", "ConfirmPasswordReset", reqInfo);
	const res = await Api.post(req);
	return res.data.payload;
}
const refreshToken = async () => {
	const req = buildRequest("AuthService", "GetWSRefreshToken", {});
	const refToken = localStorage.getItem("refreshToken");
	const connectionId = getConnectionIdLS()
   if(!refToken && (!connectionId || connectionId===undefined) ) return 

	return Api.post(req ,{
		headers: {
			"Authorization": `Bearer ${refToken}`,
			'X-Previous-Connection-Id': connectionId
		}
	});
};
export const UserServiceClientApi = {
	getSubcribeBotsList,
	getUserDomainsList,
	getContacts,
	downloadFile,
	subscribeDomain,
	deleteUser,
	changePassword,
	initiateSoftwareMfa,
	activeSoftwareMfa,
	deactivateSoftwareMfa,
	execute,
	// fetchUserDetails
	getCallHistory,
	getPaginatedCallHistory,
	sendVoipCall,
	getCatalog,
	subscribeBot,
	getTimeLine,
	updateMessageStatusForUser,
	generateTwilioToken,
	getSubcribeChannelList,
	getContactHistory,
	updateFavourites,
	createNewGroup,
	addGroupParticipants,
	getParticipants,
	editChannel,
	updateChannelAdmin,
	getSubscribedChannels,
	getUnsubscribedChannels,
	unsubscribeChannel,
	sendUserAvailableForCall,
	deleteChannel,
	updateParticipants,
	fetchUserDetails,
	leaveCall,
	rejectCall,
	fetchFavourite,
	initiateStripePayment,
	confirmStripePayment,
	signupUser,
	verifyOtp,
	resendOtp,
	resetPassword,
	confirmPassword,
	refreshToken
};
